import { render, staticRenderFns } from "./userInfoSet.vue?vue&type=template&id=35cc9d4a&scoped=true&"
import script from "./userInfoSet.vue?vue&type=script&lang=js&"
export * from "./userInfoSet.vue?vue&type=script&lang=js&"
import style0 from "./userInfoSet.vue?vue&type=style&index=0&id=35cc9d4a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc9d4a",
  null
  
)

export default component.exports